import clsx from 'clsx'
import {PropsWithChildren} from 'react'
import {HeaderProps} from 'react-table'
import {getSortIcon} from '../../Functional'

type TableCustomHeaderProps<T extends object> = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<T>>
  useQueryRequest?: () => {state: any}
  isActionColumn?: boolean
}

const TableCustomHeader = <T extends object>({
  className,
  title,
  tableProps,
  useQueryRequest,
  isActionColumn = false,
}: TableCustomHeaderProps<T>) => {
  const {column} = tableProps
  const {state} = useQueryRequest?.() ?? {state: {}}

  const isSorted = column.isSorted
  const isSortedDesc = column.isSortedDesc
  const canSort = column.canSort

  const isDefaultSortedColumn = column.id === state.sort
  const defaultSortOrder = state.order

  return (
    <th
      {...column.getHeaderProps(column.getSortByToggleProps())}
      className={clsx(className, 'text-uppercase vertical-align-middle')}
    >
      <div className={`header-content-wrapper ${isActionColumn ? 'justify-content-end' : ''}`}>
        {title}
        {canSort && getSortIcon(isSorted, isSortedDesc, isDefaultSortedColumn, defaultSortOrder)}
      </div>
    </th>
  )
}

export {TableCustomHeader}
